import React from "react";
import cn from "classnames";

import { icons } from "constants/icons";
import { SortConfig, SortDirection } from "types/common";

const TableHeader: React.FC<{
  onClick: (sortBy: string) => void;
  sortConfig?: SortConfig;
  style?: object;
  headerList: {
    title?: string;
    sortBy?: string;
    width?: number;
    marginLeft?: number;
  }[];
}> = ({ onClick, sortConfig, headerList, style }) => {
  const handleClick = (item: any) => {
    onClick(item.sortBy ?? "");
  };
  return (
    <div
      className="w-full flex items-center text-grayDark text-[10px] px-3 mb-2.5"
      style={style}
    >
      {headerList.map((item) => {
        return (
          <div
            key={item.title}
            className="space-x-1 text-left relative"
            style={{ width: item.width }}
          >
            {item.title && (
              <button
                type="button"
                onClick={() => handleClick(item)}
                className=" flex items-center space-x-2"
              >
                <strong>{item.title}</strong>
                {sortConfig && (
                  <img
                    src={
                      sortConfig.sortBy === item.sortBy
                        ? sortConfig.sortDirection === SortDirection.asc
                          ? icons.carrotDownGreen
                          : icons.carrotDownRed
                        : icons.carrotDown
                    }
                    alt="arrow"
                    className={cn("transition-all mt-[0.5px]", {
                      "rotate-180":
                        sortConfig.sortBy === item.sortBy &&
                        sortConfig.sortDirection === SortDirection.asc,
                    })}
                  />
                )}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TableHeader;
